import React from "react";
import { Upload } from "lucide-react";
import { useImportModal } from "../../_helper/Import/ImportProvider";
import { IconButton } from "../../design-system";

/**
 * Import butonu — design-system IconButton üzerine kuruludur. İki mod:
 *   - default: metin + ikon, ferah yatay buton (size="auto")
 *   - iconOnly: 36×36 kompakt kare buton (kalabalık toolbar'larda)
 */
export default function ImportButton({
  title = "Import",
  label = "Import",
  columns,
  fields,
  schema,
  sampleData,
  sampleFileName,
  sampleSheetName,
  multiple,
  setRows,
  onImport,
  idKey,
  variant = "outlined",
  iconOnly = false,
  ariaLabel,
}) {
  const { openImport } = useImportModal();

  const handleClick = () => {
    openImport({
      title,
      columns,
      fields,
      schema,
      sampleData,
      sampleFileName,
      sampleSheetName,
      multiple,
      setRows,
      onImport,
      idKey,
    });
  };

  return (
    <IconButton
      variant={variant}
      size={iconOnly ? "md" : "auto"}
      ariaLabel={ariaLabel || label}
      onClick={handleClick}
    >
      <Upload size={16} aria-hidden />
      {!iconOnly ? <span>{label}</span> : null}
    </IconButton>
  );
}
